<template>
  <b-modal
    :id="modalId"
    modal-class="p-4 big-modal"
    dialog-class="modal-lg"
    content-class="text-center pb-2"
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    hide-footer
    lazy
  >
    <div class="gigawhat-modal ml-3 mb-2 ">
      <div class="modal-heading mt-3 ">
        <h2 class="modal-title">
          Attacher document à des opérations
        </h2>
        <p class="modal-description">
          Choisir les opérations pour sujet d'attachement à ce document
        </p>
      </div>
      <div v-if="!isMassActions" class="giga-files_upload">
        <div class="giga-files_upload_section">
          <div class="giga-files_upload_header">
            <div class="giga-files_header_col_action"></div>
            <div class="giga-files_header_col_name">
              <h3 class="giga-files_upload_title">
                Nom du document
              </h3>
            </div>
            <div class="giga-files_header_col_type">
              <h3 class="giga-files_upload_title">
                Type
              </h3>
            </div>
            <div class="giga-files_header_col_date">
              <h3 class="giga-files_upload_title">
                Date de transmission
              </h3>
            </div>
          </div>
          <div class="giga-upload_files_list">
            <div class="giga-upload_file_item">
              <div class="giga-upload_file_name">
                <i class="extention-icon">
                  <img
                    v-if="
                      getFileExtention(selectedDocument.originalFileName) ==
                        'xlsx'
                    "
                    src="~@/assets/images/extensions/xls.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(selectedDocument.originalFileName) ==
                        'txt'
                    "
                    src="~@/assets/images/extensions/txt.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(selectedDocument.originalFileName) ==
                        'pdf'
                    "
                    src="~@/assets/images/extensions/pdf.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(selectedDocument.originalFileName) ==
                        'docx'
                    "
                    src="~@/assets/images/extensions/doc.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(selectedDocument.originalFileName) ==
                        'doc'
                    "
                    src="~@/assets/images/extensions/doc.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(selectedDocument.originalFileName) ==
                        'zip'
                    "
                    src="~@/assets/images/extensions/zip.svg"
                  />
                  <img v-else src="~@/assets/images/extensions/text.svg" />
                </i>
                {{ selectedDocument.originalFileName }}
              </div>
              <div class="giga-upload_file_type">
                <span v-if="Array.isArray(selectedDocument.types)">
                  {{ selectedDocument.types.map(type => type.name).join(", ") }}
                </span>
                <span v-else>
                  {{ selectedDocument.types.name }}
                </span>
              </div>
              <div class="giga-upload_file_date">
                <span v-if="selectedDocument.creationDate"
                  >{{
                    moment(selectedDocument.creationDate, "x").format(
                      "DD/MM/YYYY"
                    )
                  }}
                </span>
                <span v-else>{{ new Date().toLocaleDateString("fr-FR") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMassActions" class="giga-files_upload">
        <div class="giga-files_upload_section">
          <div class="giga-files_upload_header">
            <div class="giga-files_header_col_date">
              <h3 class="giga-files_upload_title">
                ID Réf Client
              </h3>
            </div>
            <div class="giga-files_header_col_date">
              <h3 class="giga-files_upload_title">
                Réf Client
              </h3>
            </div>

            <div class="giga-files_header_col_date">
              <h3 class="giga-files_upload_title">
                Nombre des documents sélectionnées
              </h3>
            </div>
            <div class="giga-files_header_col_name">
              <h3 class="giga-files_upload_title">
                Nom des documents
              </h3>
            </div>
          </div>
          <div class="giga-upload_files_list">
            <div class="giga-upload_file_item">
              <div class="giga-upload_file_date">
                {{ simulation.id }}
              </div>
              <div class="giga-upload_file_date">
                {{ simulation.name }}
              </div>
              <div class="giga-upload_file_date">
                {{ selectedDocuments.length }}
              </div>
              <div class="giga-upload_file_name">
                {{ selectedDocuments.map(doc => doc.name).join(", ") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <OperationList
        v-if="isSimulation"
        :operations="getAssignOperations.content"
        :is-selected="true"
        :is-deleted="false"
        @operation-selection-changed="handleSelection"
        :selected-operations="selectedOperations"
        :is-simulation="isSimulation"
        :selectedDocument="selectedDocument"
        :is-mass-actions="isMassActions"
      ></OperationList>
      <OperationList
        v-else
        :operations="getWorkOperations.content"
        :is-selected="true"
        :is-deleted="false"
        :is-simulation="isSimulation"
        @operation-selection-changed="handleSelection"
        :selected-operations="selectedOperations"
        :selected-document="selectedDocument"
        :is-mass-actions="isMassActions"
      ></OperationList>
      <div class="gigwhat-model_footer mt-5">
        <div class="half-footer left-content">
          <div class="giga-button">
            <button
              id="btn-leave"
              class="giga-blue_outlined_button no-icon"
              @click="closeAssignModal()"
            >
              Quitter
            </button>
          </div>
        </div>
        <div class="half-footer right-content">
          <div class="giga-button">
            <button
              v-if="!isMassActions && selectedDocument"
              id="btn-submit"
              class="giga-green_button no-icon mr-5"
              @click="addOperations()"
              :disabled="isDisabled"
            >
              Terminer
            </button>
            <button
              v-if="
                isMassActions &&
                  selectedDocuments &&
                  selectedDocuments.length > 0
              "
              id="btn-submit"
              class="giga-green_button no-icon mr-5"
              @click="editDocumentsOperations()"
              :disabled="isDisabled"
            >
              {{ $t("save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { queryConstant } from "@/shared/queryConstant";
import OperationList from "@/components/static/AddDocument/OperationList.vue";
import { documentService } from "@/views/service/document.service";
import eventBus from "@/shared/event.bus";
import { constants } from "@/shared/constants";

export default {
  name: "AssignDocumentOperation",
  components: { OperationList },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      length: [10, 25, 50],
      sortBy: null,
      sortDir: "asc",
      customFilter: queryConstant.setDefaultCustomFilter(),
      currentFilter: {},
      queryConfig: queryConstant.SIMULATION_OPERATION_CONFIG,
      search: "",
      selectAllOperations: false,
      operations: {
        type: Array,
        default: () => []
      },
      isDisabled: false,
      allowedStatus: constants.ALLOWED_OPERATIONS_STATUS,
      initialSelectedOperations: []
    };
  },
  props: {
    selectedDocument: {
      type: Object
    },
    selectedOperations: [],
    isMassActions: {
      type: Boolean,
      default: true
    },
    modalId: {
      type: String,
      required: true
    },
    isSimulation: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters("simulation", ["getOperations", "getAssignOperations"]),
    ...mapGetters("simulation", {
      currentStep: "getCurrentStep",
      simulationType: "getSimulationType",
      simulation: "getSimulation",
      isCurrentStep: "isCurrentStep",
      steps: "getSteps",
      componentName: "getComponentName",
      simulationChanged: "getSimulationChanged"
    }),
    ...mapGetters("document", {
      selectedDocuments: "getSelectedDocuments"
    }),
    ...mapGetters("work", ["getWorkOperations"])
  },
  mounted() {
    this.initialSelectedOperations = this.selectedOperations;
  },
  methods: {
    ...mapActions("notification", ["closeModal"]),
    addOperations() {
      this.$emit("selectedOperations", this.selectedOperations);
      this.closeModal({ instance: this.$root, id: this.modalId });
    },
    closeAssignModal() {
      this.closeModal({ instance: this.$root, id: this.modalId });
    },
    handleSelection(operations) {
      if (this.initialSelectedOperations.length === operations.length) {
        this.isDisabled = this.initialSelectedOperations.every(o =>
          operations.some(op => o.id === op.id)
        );
      } else {
        this.isDisabled = false;
      }
      this.selectedOperations = operations;
    },
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    editDocumentsOperations() {
      const documentsOperations = {
        documentIds: this.selectedDocuments.map(doc => doc.id),
        operationIds: this.selectedOperations.map(operation => operation.id)
      };
      documentService.editDocumentOperations(documentsOperations);
      this.closeModal({ instance: this.$root, id: this.modalId });
      eventBus.$emit("reloadDocuments", null);
    }
  }
};
</script>

<style scoped lang="scss">
.giga-files_upload_section {
  padding: 10px 30px 10px 100px;
  border-radius: 6px;
  border: 2px solid #e0e7ee;
  width: 96%;
  background-color: #f4f6fa;
  .giga-files_upload_header {
    display: flex;
    flex-wrap: wrap;

    .giga-files_header_col_name {
      flex: 0 0 40%;
      max-width: 45%;
    }

    .giga-files_header_col_date {
      flex: 0 0 18%;
      max-width: 45%;
    }

    .giga-files_header_col_type {
      flex: 0 0 35%;
      max-width: 45%;
    }
  }
}

.giga-upload_files_list {
  .giga-upload_file_item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .giga-upload_file_date {
      flex: 0 0 18%;
      max-width: 45%;
    }

    .giga-upload_file_type {
      flex: 0 0 35%;
      max-width: 45%;
    }

    .giga-upload_file_name {
      flex: 0 0 65%;
      max-width: 45%;
      font-size: 15px;
      font-weight: 600;
      color: #132d48;
      display: flex;
      align-items: center;

      .extention-icon {
        width: 40px;
        height: 40px;
        border-radius: 6px;
        background-color: #e0e7ee;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 15px;

        img {
          width: 20px;
        }
      }
    }
  }
}
</style>
